import React from 'react';
import { Button } from "@mui/material";
import { Delete, OpenWith, RotateLeft } from "@mui/icons-material";
import chartingMenuSx from './ChartingMenu.styles';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';
import { useDispatch, useSelector } from "react-redux";
import { actions } from '../Chart.redux';



const MenuLayers = () => {
	const theme = useTheme();
	const sx = chartingMenuSx(theme);
	const dispatch       = useDispatch(),
		  selectedDelete = useSelector(state => state.chart.toolbar.selectedButton === 'delete'),
		  selectedMove   = useSelector(state => state.chart.toolbar.selectedButton === 'move'),
		  selectedRotate = useSelector(state => state.chart.toolbar.selectedButton === 'rotate');

	const setTool = toolName => e => {
		dispatch(actions.setToolbar({ selectedButton: toolName, selectedTool: toolName }));
	};


	return (
		<>
			<Button
				variant="outlined"
				sx={{ ...sx.buttonMarginRight, ...sx.buttonFloat, ...sx.buttonSmall }}
				color={selectedMove
					? "primary"
					: undefined}
				onClick={setTool('move')}
			>
				<OpenWith />
			</Button>


			<Button
				variant="outlined"
				sx={{ ...sx.buttonMarginRight, ...sx.buttonFloat, ...sx.buttonSmall }}
				color={selectedRotate
					? "primary"
					: undefined}
				onClick={setTool('rotate')}
			>
				<RotateLeft />
			</Button>


			<Button
				variant="outlined"
				sx={{ ...sx.buttonMarginRight, ...sx.buttonFloat, ...sx.buttonSmall }}
				color={selectedDelete
					? "primary"
					: undefined}
				onClick={setTool('delete')}
			>
				<Delete />
			</Button>
		</>
	);
};



export default MenuLayers;
